<div class="sk-container" [ngClass]="{ 'sk-loading': (state.loading && !state.error) || !racingEdpReady }">
    <loading-screen [displayed]="(state.loading && !state.error) || !racingEdpReady"></loading-screen>
    @if (state.error) {
        <request-error [loadFailed]="state.error" (reloadFn)="reloadComponent()"> </request-error>
    }
    @if (
        isLoadMystableOnboarding &&
        (mystableSelectedMarketPath == 'win-or-each-way' || isMarketAntepost) &&
        userService?.status &&
        eventEntity.isUKorIRE &&
        eventEntity.categoryId === '21'
    ) {
        <lazy-component
            moduleUri="@lazy-modules-module/myStableRacingModule/mystable-racing.module#myStableRacingModule"
            entryComponent="MyStableOnboardingComponent"
            [inputs]="{ eventEntity: eventEntity, isMarketAntepost: isMarketAntepost }">
        </lazy-component>
    }
    @if (!state.loading && !state.error && racingEdpReady) {
        <racing-event
            [sportName]="racingName"
            [eventId]="eventId"
            [loadFloatingMsgComp]="loadFloatingMsgComp"
            [origin]="origin"
            [selectedTypeName]="selectedTypeName"
            [selectedMarketPath]="selectedMarketPath"
            [selectedMarketTypePath]="selectedMarketTypePath"
            [racingsMap]="racingsMap"
            [racingTypeNames]="racingTypeNames"
            [racingInMeeting]="racingInMeeting"
            [eventEntity]="eventEntity"
            [filter]="filter"
            [streamControl]="streamControl"
            [images]="images"
            [presimStopTrackInterval]="presimStopTrackInterval"
            [onExpand]="onExpand"
            [meetingsTitle]="meetingsTitle"
            [quickNavigationItems]="quickNavigationItems"
            [sportEventsData]="sportEventsData">
        </racing-event>
    }
    @if (isStreambetAvailable && !state.loading && !state.error && racingEdpReady) {
        <lazy-component moduleUri="@lazy-modules-module/stream-bet-tutorial-pop-up/stream-bet-tutorial-pop-up.module#StreamBetTutorialPopUpModule">
        </lazy-component>
    }
</div>
